import { useMutation, useQuery } from 'react-query';
import {
  requestResponseDetail,
  requestResponseSubmit,
} from './RequestResponse.services';
import notificationError from '@/utils/functions/notificationError';

export function useRequestResponseDetail(requestCode?: string) {
  return useQuery(
    ['request-response/detail', requestCode],
    () => requestResponseDetail(requestCode),
    {
      enabled: !!requestCode,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useRequestResponseSubmit() {
  return useMutation(requestResponseSubmit, {
    onError(error) {
      notificationError(error);
    },
  });
}
